import React from 'react'
import { PAGINATION } from '../../../constants/tables'
import * as styles from './pagination.module.scss'

export const PaginationSize = ({
   pageSize,
   totalCount,
   handleSetPageSize,
   count,
   setCount,
}: PaginationSizeProps) => {
   const allNumber = 999999

   const handleCount = (countStr: string) => {
      setCount(count + 1)
      handleSetPageSize(Number(countStr))
   }

   return (
      <div className={styles.pageSize}>
         <select
            value={pageSize}
            onChange={(el) => handleCount(el.target.value)}
         >
            {[
               PAGINATION.range1,
               PAGINATION.range2,
               PAGINATION.range3,
               PAGINATION.range4,
               allNumber,
            ].map((pageSize, index) => (
               <option key={pageSize} value={pageSize}>
                  {index === PAGINATION.index ? PAGINATION.all : pageSize}
               </option>
            ))}
         </select>
         {PAGINATION.rangeLabel}
      </div>
   )
}
